((document, window, history) => {
	const pushState = history.pushState;

	// cookie compliance banner
	function cookieCompliance() {
		if (document.querySelector('.site-farlo-ui-biscuit-banner__button')) {
			document.querySelector('.site-farlo-ui-biscuit-banner__button').addEventListener('click', (e) => {
				e.preventDefault();

				e.target.closest('.site-farlo-ui-biscuit-banner').classList.add('site-farlo-ui-biscuit-banner--hide');

				window._farlo.storage.set('cookieCompliance', 'true', 'cookie');
			});
		}

		if (document.querySelector('.site-farlo-ui-biscuit-banner__button--close')) {
			document.querySelector('.site-farlo-ui-biscuit-banner__button--close').addEventListener('click', (e) => {
				e.preventDefault();

				e.target.closest('.site-farlo-ui-biscuit-banner').classList.add('site-farlo-ui-biscuit-banner--hide');
			});
		}
	}

	// default navicon
	function navicon() {
		document.querySelector('.site-navigation__navicon').addEventListener('click', (e) => {
			e.preventDefault();
			e.currentTarget.classList.toggle('site-navigation__navicon--active');
			document.querySelector('.site-navigation').classList.toggle('site-navigation--active');
			document.body.classList.toggle('site-navigation--open');
		});
	}

	// default navigation subnav
	function navigation(submenu) {
		window._farlo.helpers.getSiblings(submenu)[ 0 ].addEventListener('click', (e) => {
			if (!e.target.classList.contains('site-navigation__menu-item--active')) {
				e.preventDefault();

				e.currentTarget.classList.add('site-navigation__menu-item--active');
				submenu.classList.add('site-navigation__sub-menu--active');

				for (let i = 0; i < window._farlo.helpers.getSiblings(e.currentTarget.parentNode).length; i += 1) {
					if (window._farlo.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 0 ] && window._farlo.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 0 ].classList.contains('site-navigation__menu-item--active')) {
						window._farlo.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 0 ].classList.remove('site-navigation__menu-item--active');
					}

					if (window._farlo.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 1 ] && window._farlo.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 1 ].classList.contains('site-navigation__sub-menu--active')) {
						window._farlo.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 1 ].classList.remove('site-navigation__sub-menu--active');
					}
				}
			} else {
				return true;
			}
		});
	}

	function smoothScroll(_sel) {
		_sel.addEventListener('click', function(e) {
			e.preventDefault();

			if (document.querySelector('.site-navigation__navicon--active') && document.body.classList.contains('site-navigation--open')) {
				document.querySelector('.site-navigation__navicon').click();
			}

			if (e.target.parentNode.parentNode) {
				e.target.parentNode.parentNode.classList.remove('site-navigation__sub-menu--active');
			}

			if (e.target.parentNode.parentNode.parentNode) {
				e.target.parentNode.parentNode.parentNode.querySelector('a').classList.remove('site-navigation__menu-item--active');
			}

			if (e.target.href.includes('#') && document.getElementById(e.target.href.split('#')[ 1 ])) {
				document.getElementById(e.target.href.split('#')[ 1 ]).scrollIntoView({ behavior: 'smooth' });
			} else {
				window.location.href = e.target.href;
			}
		});
	}

	function entranceAnimation() {
		document.body.classList.add("no-scroll");
		document.querySelector('.site-entrance').classList.add('site-entrance--fade-out');
		window._farlo.storage.cookie.handle('entranceSeen', true, 432E3, '/', window.location.host);

		document.querySelector('.site-entrance').addEventListener('animationend', () => {
			document.body.classList.remove("no-scroll");
			document.querySelector('.site-entrance').remove();
		});
	}

	function farloUiMcSignup(_sel) {
		let farloUiSignupForm = null;


			farloUiSignupForm = new FarloUiMc(_sel.id);
		
	}

	// lightbox
	function farloUiLightbox(elem, div) {
		if (elem.querySelector('.wp-block-image')) {
			elem.querySelectorAll('.wp-block-image').forEach((_sel) => {
				_sel.addEventListener('click', (e) => {
					const clonedEmbed = e.currentTarget.cloneNode(true);
					document.body.classList.add('body--farlo-ui-lightbox-open');
					div.querySelector('.farlo-ui-lightbox__inner-content').innerHTML = '';
					div.querySelector('.farlo-ui-lightbox__inner-content').appendChild(clonedEmbed);
					div.classList.add('farlo-ui-lightbox--active');
				});
			});
		}

		if ((elem.nextElementSibling && elem.nextElementSibling.value) || (elem.querySelector('.farlo-ui-lightbox__html') && elem.querySelector('.farlo-ui-lightbox__html').value)) {
			elem.addEventListener('click', function(e) {
				e.preventDefault();
				e.stopPropagation();
				document.body.classList.add('body--farlo-ui-lightbox-open');
				div.querySelector('.farlo-ui-lightbox__inner-content').classList.add('dynamic');

				if ((e.currentTarget.nextElementSibling && e.currentTarget.nextElementSibling.value)) {
					div.querySelector('.farlo-ui-lightbox__inner-content').innerHTML = e.currentTarget.nextElementSibling.value;
				} else if (e.currentTarget.querySelector('.farlo-ui-lightbox__html') && e.currentTarget.querySelector('.farlo-ui-lightbox__html').value) {
					div.querySelector('.farlo-ui-lightbox__inner-content').innerHTML = e.currentTarget.querySelector('.farlo-ui-lightbox__html').value;
				}
				div.classList.add('farlo-ui-lightbox--active');
			});
		}

		if (elem.querySelector('a[href*="youtu.be"]')) {
			elem.querySelector('a[href*="youtu.be"]').addEventListener('click', function(e) {
				e.preventDefault();
				document.body.classList.add('body--farlo-ui-lightbox-open');
				div.querySelector('.farlo-ui-lightbox__inner-content').innerHTML = '<iframe class="farlo-ui-lightbox__inner-content-iframe" src="https://www.youtube-nocookie.com/embed/' + e.target.href.match(youTubeRegex)[ 1 ] + '" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
				div.classList.add('farlo-ui-lightbox--active');
			});
		}

		if (div.querySelector('.farlo-ui-lightbox__button-close')) {
			div.querySelector('.farlo-ui-lightbox__button-close').addEventListener('click', function(e) {
				e.preventDefault();
				document.body.classList.remove('body--farlo-ui-lightbox-open');
				e.currentTarget.closest('.farlo-ui-lightbox').classList.remove('farlo-ui-lightbox--active');
				if (div.querySelector('.farlo-ui-lightbox__inner-content.dynamic')) {
					div.querySelector('.farlo-ui-lightbox__inner-content').classList.remove('dynamic');
				}
				div.querySelector('.farlo-ui-lightbox__inner-content').innerHTML = '';

				if (elem.classList.contains('site-geo-targeting')) {
					window._farlo.storage.set('geotargeted', 'true', 'cookie');
				}
			});
		}
	}

	function faqs() {
		const accordions = document.querySelectorAll('.site-faqs__accordion-faq');

		const openAccordion = (accordion) => {
			const answer = accordion.querySelector('.site-faqs__accordion-answer');
			accordion.classList.add('site-faqs__accordion-faq--active');
			answer.style.maxHeight = answer.scrollHeight + 'px';
		};

		const closeAccordion = (accordion) => {
			const answer = accordion.querySelector('.site-faqs__accordion-answer');
			accordion.classList.remove('site-faqs__accordion-faq--active');
			answer.style.maxHeight = null;
		};

		accordions.forEach((accordion) => {
			const question = accordion.querySelector('.site-faqs__accordion-question');
			const answer = accordion.querySelector('.site-faqs__accordion-answer');

			question.onclick = () => {
				if (answer.style.maxHeight) {
					closeAccordion(accordion);
				} else {
					accordions.forEach((acc) => closeAccordion(acc));
					openAccordion(accordion);
				}
			};
		});
	}

	history.pushState = function(state) {
		if (typeof history.onpushstate === 'function') {
			history.onpushstate({ state });
		}
		return pushState.apply(history, arguments);
	};

	if (document.querySelector('.site-entrance')) {
		entranceAnimation();
	}
	document.addEventListener('DOMContentLoaded', () => {
		const lightboxEmbed = document.querySelectorAll('.site-video-embed-group, .farlo-ui-lightbox__toggle, .wp-block-gallery');
		let div;
		let divInner;
		let divInnerContent;
		let divClose;



		if (document.querySelector('.site-navigation__navicon')) {
			navicon();
		}

		if (lightboxEmbed.length > 0) {
			div = document.createElement('div');
			divInner = document.createElement('div');
			divInnerContent = document.createElement('div');
			divClose = document.createElement('button');
			div.className = 'farlo-ui-lightbox';
			divInner.className = 'farlo-ui-lightbox__inner';
			divInnerContent.className = 'farlo-ui-lightbox__inner-content';
			divClose.className = 'farlo-ui-lightbox__button-close';

			document.body.appendChild(div);
			document.querySelector('.farlo-ui-lightbox').appendChild(divInner);
			document.querySelector('.farlo-ui-lightbox__inner').appendChild(divInnerContent);
			document.querySelector('.farlo-ui-lightbox__inner').appendChild(divClose);

			lightboxEmbed.forEach(function(elem) {
				farloUiLightbox(elem, div);
			});
		}

		if (document.querySelector('.site-navigation__sub-menu')) {
			document.querySelectorAll('.site-navigation__sub-menu').forEach((_sel) => {
				navigation(_sel);
			});
		}

		if (document.querySelector('.site-farlo-ui-biscuit-banner')) {
			cookieCompliance();
		}

		if (document.querySelector('.site-faqs')) {
			faqs();
		}

		document.querySelectorAll('a[href*="#"]').forEach((_sel) => {
			smoothScroll(_sel);
		});

		if (document.querySelector('.site-farlo-ui-crm--inline')) {
			document.querySelectorAll('[farlo-ui="crm"]').forEach((_sel) => {
				farloUiMcSignup(_sel);
			});
		}

		if (document.querySelector('.site-farlo-ui-crm__toggle')) {
			document.querySelectorAll('.site-farlo-ui-crm__toggle').forEach((_sel) => {
				_sel.addEventListener('click', (e) => {
					e.preventDefault();
					e.stopImmediatePropagation();
					farloUiMcSignup(e);
				});
			});
		}

		if (document.querySelector('.site-farlo-ui-ticket-calendar')) {
			document.querySelectorAll('[farlo-ui="calendar"]').forEach((_sel) => {
				_sel.farloUiTicketCalendar(_sel);
			});
		}
	});

	window.addEventListener('load', () => {
		if (document.querySelector('.site-farlo-ui-revolver-carousel')) {
			document.querySelectorAll('[farlo-ui="carousel"]').forEach((_sel) => {
				_sel.farloUiRevolverCarousel();
			});
		}

		if (document.querySelector('.site-farlo-ui-lightbox')) {
			document.querySelectorAll('[farlo-ui="lightbox"]').forEach((_sel) => {
				_sel.farloUiLightbox();
			});
		}
	});

	const mhHeading = document.querySelector("#mh-heading");
	if (mhHeading) {
		var mhTyped = new Typed('#mh-heading-typed', {
			stringsElement: '#mh-heading',
			typeSpeed: 50,

			onComplete:function() {
				typedAbout();
				document.querySelector("#mh-heading-typed").nextSibling.style="display:none";

			}
		  });

	}

	function typedAbout() {
		const mhAbout = document.querySelector("#mh-about");
		if (mhAbout) {
			var mhAboutTyped = new Typed('#mh-about', {
				strings: ['Everything you say or do is scrutinised.', 'Even your innermost thoughts are probed.', 'You cannot be too careful.'],
				typeSpeed: 50,
				backDelay: 1500,
				loop: true,
			  });
	
		}
	}

	const entranceHeading = document.querySelector("#entrance-typed");
	if (entranceHeading) {
		var mhAboutTyped = new Typed('#entrance-typed', {
			strings: ['The Ministry of Truth is Recruiting.'],
			typeSpeed: 50,
		  });
	}

	let resizeTimer;
	window.addEventListener("resize", () => {
	  document.body.classList.add("resize-animation-stopper");
	  clearTimeout(resizeTimer);
	  resizeTimer = setTimeout(() => {
		document.body.classList.remove("resize-animation-stopper");
	  }, 400);
	});
	window.addEventListener("scroll", () => {
		document.body.classList.add("resize-animation-stopper");
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(() => {
		  document.body.classList.remove("resize-animation-stopper");
		}, 200);
	  });

	const checkScroll = () => {
		if (window.scrollY > 100 ) {
			document.body.classList.add("scrolled");
		} else {
			document.body.classList.remove("scrolled");
		}
	}
	window.addEventListener("scroll",() => {
		checkScroll();
	});
	checkScroll();

	if (typeof navigator !== 'undefined') {
		navigator.serviceWorker.getRegistrations().then(function(registrations) {
			for (const registration of registrations) {
				registration.unregister();
			}
		});
	}
	
})(document, window, history);
